<template>
  <div class="list-category-news">
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
    >
      <template #title>
        <a-row type="flex" align="middle">
          <h6 class="font-semibold m-0">Danh mục tin tức</h6>
          <router-link :to="{ name: 'CreateNewsCategory' }">
            <a-button type="primary" class="ml-20">Thêm mới</a-button>
          </router-link>
        </a-row>
      </template>
      <a-table
        :loading="callingAPI"
        :columns="columns"
        :data-source="dataSource"
        :pagination="pagination"
        @change="handleTableChangePage"
        rowKey="id"
      >
        <template slot="image" slot-scope="row">
          <img
            v-if="row.photo_url"
            :src="`${backendUrl}${row.photo_url}`"
            alt=""
            class="preview-image-table"
          />
        </template>
        <template slot="status" slot-scope="row">
          <a-switch
            v-model="row.status"
            :loading="row.loadingActive"
            @change="handleUpdate(row)"
          />
        </template>
        <template slot="action" slot-scope="row">
          <a-space>
            <router-link :to="{ name: 'UpdateNewsCategory', params: { id: row.id } }">
              <a-button shape="circle" icon="edit" size="small" />
            </router-link>
            <a-popconfirm
              placement="topRight"
              ok-text="Xóa"
              cancel-text="Hủy"
              @confirm="handleRemove(row)"
            >
              <template slot="title">
                <p>Xóa {{ row.name }} ??</p>
              </template>
              <a-button
                type="danger"
                shape="circle"
                icon="delete"
                size="small"
              />
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import {
  fetchCategory,
  removeCategory,
  updateCategory
} from "@/services/landing-page/news/category";
import ENDPOINT from "@/config/endpoint";

export default {
  name: "ListCategory",
  data() {
    return {
      callingAPI: false,
      backendUrl: ENDPOINT.BACKEND_URL,

      pagination: {
        total: 0,
        pageSize: 10,
        current: 1
      },
      

      dataSource: [],
      columns: [
        {
          title: "Tên",
          dataIndex: "name",
          scopedSlots: { customRender: "name" },
          class: "font-semibold",
          width: 250
        },
        {
          title: "Nội dung",
          dataIndex: "content",
          scopedSlots: { customRender: "content" },
          class: "font-semibold",
          width: 250
        },
        {
          title: "Hiển thị",
          scopedSlots: { customRender: "status" },
          width: 100,
          align: "center"
        },
        {
          scopedSlots: { customRender: "action" },
          width: 50
        }
      ]
    };
  },
  async beforeMount() {
    await this.loadData();
  },
  methods: {
    async loadData(loading = true) {
      try {
        this.callingAPI = loading;
        const params = {
          per_page: this.pagination.pageSize,
          page: this.pagination.current
        };
        const response = await fetchCategory(params);
        this.dataSource = response.data.data.map(d => ({
          ...d,
          status: d.status === 1,
          loadingActive: false
        }));
        this.pagination.total = response.data.total;
        this.callingAPI = false;
      } catch (error) {
        this.callingAPI = false;
      }
    },

    async handleTableChangePage(pagination) {
      this.pagination.current = pagination.current;
      await this.loadData();
    },

    async handleRemove(row) {
      try {
        this.callingAPI = true;
        const response = await removeCategory(row.id);
        if (response.status === 1) {
          this.$notification.success({
            message: "Thành công",
            description: "Xóa thành công"
          });
        } else {
          this.$notification.error({
            message: "Thất bại",
            description: "Xóa thất bại"
          });
        }
        this.pagination.current = this.dataSource?.length > 1 ? this.pagination.current : Math.max(this.pagination.current - 1, 1)
        await this.loadData();
        this.callingAPI = false;
      } catch (error) {
        this.$notification.error({
          message: "Thất bại",
          description: "Xóa thất bại"
        });
        this.callingAPI = false;
      }
    },
    async handleUpdate(row) {
      try {
        const formData = new FormData()
        formData.append("name", row.name);
        formData.append("content", row.content);
        formData.append("status", row.status ? 1 : 2);
        formData.append("_method", "PUT");
        const response = await updateCategory(row.id, formData);
        if (response.status === 1) {
          this.$notification.success({
            message: 'Thành công',
            description: 'Cập nhật trạng thái hiển thị thành công.',
          });
        } else {
          this.$notification.error({
            message: 'Thất bại',
            description: 'Cập nhật trạng thái hiển thị thất bại.',
          });
        }
      } catch (error) {
        console.log(error)
      }
    },
  }
};
</script>

<style lang="scss" scoped>
</style>